import { Component, ElementRef, OnInit, AfterViewInit, Renderer2 } from '@angular/core';

import { NestedTreeControl } from '@angular/cdk/tree';

import { MatTreeNestedDataSource } from '@angular/material/tree';

import { UmsService } from '../ums.service';

import { TranslateService } from '@ngx-translate/core';

import { Router } from '@angular/router';
import { ChangePasswordComponent } from '../change-password/change-password.component';
import { MatDialog } from '@angular/material/dialog';
import { log } from 'console';
import { DatePipe } from '@angular/common';
import { NgxSpinnerService } from 'ngx-spinner';
import { HttpErrorResponse } from '@angular/common/http';

interface FoodNode {
  name: string;

  icon: string;

  children?: FoodNode[];
}

@Component({
  selector: 'app-header',

  templateUrl: './header.component.html',

  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit, AfterViewInit {
  default = true;
  aaa = false;
  showSubMenu = false;
  username = 'teacher';
  role = 'teacher';
  menu = 'teacher';
  defaultlang = 'mr';
  menurole = 'student';
  treeControl = new NestedTreeControl<FoodNode>((node) => node.children);
  dataSource = new MatTreeNestedDataSource<FoodNode>();
  headerlist;
  listParentMenu: any;
  userId: string;
  userData = {
    LoginFullName: 'N/A'
  }
  currentsession: any;
  permissionData: any;
  uType: any;
  disabledMenu = false;
  userPermission: any;
  utp: string;
  dashboardMenu = true;
  masterMenu = true;
  superMenu = true;
  prcessMenu = true;
  adminMenu = true;
  inputMenu = true;
  settingMenu = true;
  reportMenu = true;
  CollegeView = true;
  FacultyView = true;
  CourseView = true;
  CoursewiseAttThresoldMasterView = true;
  CollegeMappingView = true;
  CodeTypeView = true;
  ExamView = true;
  SubjectMappingView = true;
  ChoiceSubjectView = true;
  CountryView = true;
  StateView = true;
  DistrictView = true;
  DivisionView = true;
  TownView = true;
  SessionView = true;
  CourseIntakeMappingView = true;
  SessionCutoffView = true;
  SupervisorCourseView = true;
  SupervisorExamView = true;
  UserPermissionView = true;
  AssignLevelView = true;
  IAUserView = true;
  ExamScheduleView = true;
  ExamEditScheduleView = true;
  CourseScheduleView = true;
  CourseEditScheduleView = true;
  NewExamCodeView = true;
  ExamTimetableView = true;
  QuestionPaperCodesView = true;
  GenerateRegnNoView = true;
  GenerateRollNoView = true;
  GenerateSheetsView = true;
  GenerateCodesView = true;
  CenterCodesView = true;
  PracticalBatch =true;
  ZoneAllocationView = true
  GenerateMarksFoilsView = true
  ProcessResultView = true
  UpdateResultsView = true
  ReProcessResultView = true
  SwitchSessionView = true
  RegistrationView = true;
  ExamInputView = true;
  CenterView = true;
  New_CenterView = true;
  CollegeCapacity = true;
  BarcodeNameView = true;
  BarcodeMarksView = true;
  ControlSheetsView = true;
  MarksByRollNoView = true;
  MarksByCodeView = true;
  StatusReportView = true;
  ChangeMarksView = true;
  SectionMarksView = true;
  DistAssMarksView = true;
  IAMarksView = true;
  StudentHoldData = true;
  StudentProfileSettingView = true;
  ExamSetupView = true;
  FeeHeadView = true;
  FeeTemplateView = true;
  FeeTemplateMappingView = true;
  FeeModeView = true;
  ApplyFeeTemplateView = true;
  examFeeView = true;
  ScrutinyApprovalView = true;
  StudentAttendanceView = true;
  StudentIAAttendanceView = true;
  TehasilView = true;
  AttendanceSettingView = true;
  IAAtdSettingView = true;
  Cast = true;
  SubCast = true;
  StudentStatus = true;
  PackingList = true;
  SubjectChange = true;
  AdminOptionalSubjectSelection = true;
  WithHold = true;
  UploadStudentData = true;
  CasteWiseIntakeView = true;
  holidayView = true
  ParameterView = true;
  ComplaintView = true;
  SLMView = true;
  RevaluationView = true;
  codetypeforadmin
  notificationsView = true;
  tentativeView = true;
  tentativeDetailsView = true;
  UploadStudentPhotoAndSign = true;
  UploadOldStudentPhotoAndSign = true;
  UploadConvocation = true;
  ExamFormCollegeReport = true;
  IAMarks = true;
  BlockWiseReport = true;
  MarksDataUploadSheets = true;
  Buffer_Student_Answersheet = true;
  ExamsEvalMarksReport = true;
  PracticalMarksReport = true;
  PracticalMarks = true;
  collegewiselist = true;
  ElectiveMarks = true;
  StudentSignPhotoUploadReport = true;
  DepartmentView = true;
  DepartmentSubjectMappingView = true;
  ExaminerView = true;
  ExaminerAvailability = true;
   ExaminerEligibility = true;
  PracticalExaminerAssignment = true;
  PracticalTimeTable = true;
  EligibilityCriteria = true;
  AssignPanelDate = true;
  activeMenu: string = '';
  date: string;
  AdminUser
  zoomLevel: number = 1;
  SkipAttendance: boolean;
  NotificationsData: any[];
  UserCollege: any;
  SessionNo: any;
  NotificationCount: any;
  NotificationAllData: any;
  errMsg: any;
  userType: string;
  TeacherLogin: boolean;
  TheoryExamAppointment = true;

  constructor(
    private elRef: ElementRef, private spinner: NgxSpinnerService,
    public umsService: UmsService,
    private dialog: MatDialog,
    private translate: TranslateService,
    public router: Router,
    public datepipe: DatePipe,
    private renderer: Renderer2
  ) {
    translate.setDefaultLang('en');
    this.mysecret();
  }
  todayDate: Date = new Date();
  ngOnInit(): void {
    this.date = this.datepipe.transform(this.todayDate, 'yyyy');
    this.headerlist = JSON.parse(localStorage.getItem('headerlist'));
    this.userId = sessionStorage.getItem('userId');
    if (this.userId == '1') {
      this.AdminUser = true
    }
    else {
      this.AdminUser = false
    }
    this.getUserData(this.userId);
    if (JSON.parse(sessionStorage.getItem("session")) == null) {
      this.fetchSecretData();
    }
    else if (JSON.parse(sessionStorage.getItem("session")) != null) {
      let sessionData = JSON.parse(sessionStorage.getItem("session"));
      this.SessionNo = sessionData.SnNo
      this.getUserPermission(this.SessionNo);
    }
    // this.getUserPermission()
    this.getSecretData()

    let the = localStorage.getItem('theme');
    if (the == null) {
      this.theme('blue')
    } else {
      if (the.length <= 0) {
        this.theme('blue');
      } else {
        this.theme(the);
      }
    }
    this.ngAfterViewInit();


  }

  fetchSecretData() {
    this.spinner.show()
    this.umsService.getSecretData().subscribe((res) => {
      if (res.status) {
        this.spinner.hide()
        this.SessionNo = res.projectPharam['SnNo']
        this.getUserPermission(this.SessionNo);
      }
      else {
        this.spinner.hide()
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    }
    );
  }
  ngAfterViewInit(): void {
    this.aaa = true;
    // this.getPer();

  }

  getUserData(id) {
    this.umsService.getUserData(id).subscribe((res) => {
      this.userData = res.data[0][0];
      sessionStorage.setItem('userType', res.data[0][0].LoginLevel)
      sessionStorage.setItem('TLoginName', res.data[0][0].LoginName)

      this.usertyp();
    });
  }



  usertyp() {
    this.uType = sessionStorage.getItem('userType')
    if (this.uType == 11) {
      let user = 'Super Admin'
      this.userType = 'Super Admin'
      sessionStorage.setItem('usertypeee', user);
    }
    else if (this.uType == 10) {
      let user = 'Admin'
      this.userType = 'Admin'
      sessionStorage.setItem('usertypeee', user);
    }
    else if (this.uType == 6) {
      let user = 'User'
      this.userType = 'User'
      sessionStorage.setItem('usertypeee', user);
    }
    else if (this.uType == 1) {
      let user = 'Teacher'
      this.userType = 'Teacher'
      sessionStorage.setItem('usertypeee', user);
    }
    else {
      let user = 'Student'
      this.userType = 'Student'
      sessionStorage.setItem('usertypeee', user);
    }


    if (this.userType == 'Teacher' || this.userType === 'Teacher') {
      this.TeacherLogin = true
    } else {
      this.TeacherLogin = false
    }

  }

  useLanguage(language: string) {
    if (language === 'mr') {
      this.defaultlang = 'en';
    } else {
      this.defaultlang = 'mr';
    }

    this.translate.use(language);
  }

  getUserPermission(SnNo) {
    let payload = {};
    payload['UserId'] = this.userId;
    this.umsService.getPermission(payload).subscribe(res => {
      if (res.status) {
        this.permissionData = res.data;
        sessionStorage.setItem('userPermission', JSON.stringify(res.data))
        this.userPermission = JSON.parse(sessionStorage.getItem("userPermission"));
        this.utp = sessionStorage.getItem('usertypeee');
        if (this.utp == 'Super Admin') {
          this.StudentProfileSettingView = true;
          this.ExamSetupView = true;
        }
        else {
          this.StudentProfileSettingView = false;
          this.ExamSetupView = false;
        }
        this.getList(res.data[0], SnNo)
        if (this.utp !== 'Super Admin') {
          this.codetypeforadmin = false;
          this.StudentProfileSettingView = false;
          this.ExamSetupView = false;
          if (res.data.length != 0) {
            var BreakException = {};
            this.userPermission.forEach(element => {
              if (element.PageName == 'Dashboard' && element.PView == false) {
                this.dashboardMenu = false;

              }
              if (element.PageName == 'Master' && element.PView == false) {
                this.masterMenu = false;
              }
              if (element.PageName == 'College' && element.PView == false) {
                this.CollegeView = false;
              }
              if (element.PageName == 'Faculty' && element.PView == false) {
                this.FacultyView = false;
              }
              if (element.PageName == 'Course' && element.PView == false) {
                this.CourseView = false;
              }
               if (element.PageName == 'Coursewise Attendance Threshold' && element.PView == false) {
                this.CoursewiseAttThresoldMasterView = false;
              }
              if (element.PageName == 'College-Mapping' && element.PView == false) {
                this.CollegeMappingView = false;
              }
              // if (element.PageName == 'Code-Type' && element.PView == false) {
              //   // this.CodeTypeView = true;
              //   this.codetypeforadmin = false;
              // }
              if (element.PageName == 'Exam' && element.PView == false) {
                this.ExamView = false;
              }
              if (element.PageName == 'Subject-setup' && element.PView == false) {
                this.SubjectMappingView = false;
              }
              if (element.PageName == 'Choice-Subject' && element.PView == false) {
                this.ChoiceSubjectView = false;
              }
              if (element.PageName == 'Country' && element.PView == false) {
                this.CountryView = false;
              }
              if (element.PageName == 'State' && element.PView == false) {
                this.StateView = false;
              }
              if (element.PageName == 'District' && element.PView == false) {
                this.DistrictView = false;
              }
              if (element.PageName == 'Division' && element.PView == false) {
                this.DivisionView = false;
              }
              if (element.PageName == 'Town' && element.PView == false) {
                this.TownView = false;
              }
              if (element.PageName == 'Tehasil' && element.PView == false) {
                this.TehasilView = false;
              }
              if (element.PageName == 'Subject Attendance' && element.PView == false) {
                this.AttendanceSettingView = false;
              }
              
              if (element.PageName == 'Practical Attendance' && element.PView == false) {
                this.IAAtdSettingView = false
              }

              if (element.PageName == 'Department' && element.PView == false) {
                this.DepartmentView = false
              }
              if (element.PageName == 'Department-Subject-Mapping' && element.PView == false) {
                this.DepartmentSubjectMappingView = false
              }
              if (element.PageName == 'Examiner Profile' && element.PView == false) {
                this.ExaminerView = false
              }
                if (element.PageName == 'Examiner Eligibility Add' && element.PView == false
              ) {
                this.ExaminerEligibility = false;
              }
              if (element.PageName == 'Examiner Availability Request' && element.PView == false) {
                this.ExaminerAvailability = false
                this.ExaminerEligibility = false;
              }
                if(element.PageName == 'Eligibility Criteria' && element.PView == false){
                this.EligibilityCriteria = false;
              }
              if (element.PageName == 'Practical Examiner Assignment' && element.PView == false) {
                this.PracticalExaminerAssignment = false
              }

              //admin
              if (element.PageName == 'Admin' && element.PView == false) {
                this.adminMenu = false;
              }
              if (element.PageName == 'Session' && element.PView == false) {
                this.SessionView = false;
              }
              if (element.PageName == 'Course Intake Mapping' && element.PView == false) {
                this.CourseIntakeMappingView = false;
              }
              if (element.PageName == 'Session-Cutoff' && element.PView == false) {
                this.SessionCutoffView = false;
              }
              if (element.PageName == 'Supervisor-Course' && element.PView == false) {
                this.SupervisorCourseView = false;
              }
              if (element.PageName == 'Supervisor-Exam' && element.PView == false) {
                this.SupervisorExamView = false;
              }
              if (element.PageName == 'User-Permission' && element.PView == false) {
                this.UserPermissionView = false;
              }
              if (element.PageName == 'Admission Approval Level' && element.PView == false) {
                this.AssignLevelView = false;
              }
              if (element.PageName == 'IA User' && element.PView == false) {
                this.IAUserView = false;
              }
              if (element.PageName == 'Caste Wise Intake' && element.PView == false) {
                this.CasteWiseIntakeView = false;
              }
              //supervisor

              if (element.PageName == 'Supervisor' && element.PView == false) {
                this.superMenu = false;
              }
              if (element.PageName == 'Exam-Schedule' && element.PView == false) {
                this.ExamScheduleView = false;
              }
              if (element.PageName == 'Exam-Edit-Control' && element.PView == false) {
                this.ExamEditScheduleView = false;
              }
              if (element.PageName == 'Course-Schedule' && element.PView == false) {
                this.CourseScheduleView = false;
              }
              if (element.PageName == 'Course-Edit-Control' && element.PView == false) {
                this.CourseEditScheduleView = false;
              }
              if (element.PageName == 'New-Exam-Code' && element.PView == false) {
                this.NewExamCodeView = false;
              }
              if (element.PageName == 'Exam-Timetable' && element.PView == false) {
                this.ExamTimetableView = false;
              }
              if (element.PageName == 'Practical TimeTable' && element.PView == false) {
                this.PracticalTimeTable = false;
              }
              if (element.PageName == 'Assign Panel Date' && element.PView == false) {
                this.AssignPanelDate = false;
              }
              if (element.PageName == 'Question-Paper-Codes' && element.PView == false) {
                this.QuestionPaperCodesView = false;
              }
              //processing

              if (element.PageName == 'Processing' && element.PView == false) {
                this.prcessMenu = false;
              }
              if (element.PageName == 'Generate RegnNo' && element.PView == false) {
                this.GenerateRegnNoView = false;
              }
              if (element.PageName == 'Generate Roll No' && element.PView == false) {
                this.GenerateRollNoView = false;
              }
              if (element.PageName == 'Generate Control Sheet' && element.PView == false) {
                this.GenerateSheetsView = false;
              }
              if (element.PageName == 'Generate Codes' && element.PView == false) {
                this.GenerateCodesView = false;
              }
              if (element.PageName == 'Center Codes' && element.PView == false) {
                this.CenterCodesView = false;
              }
              if (element.PageName == 'Zone Allocation' && element.PView == false) {
                this.ZoneAllocationView = false;
              }
              if (element.PageName == 'Generate Marks Foils' && element.PView == false) {
                this.GenerateMarksFoilsView = false;
              }
              if (element.PageName == 'Process Result' && element.PView == false) {
                this.ProcessResultView = false;
              }
              if (element.PageName == 'Update Results' && element.PView == false) {
                this.UpdateResultsView = false;
              }
              if (element.PageName == 'Re-Process Result (Changes)' && element.PView == false) {
                this.ReProcessResultView = false;
              }
              if (element.PageName == 'Switch Session' && element.PView == false) {
                this.SwitchSessionView = false;
              }
              if (element.PageName == 'Marks Data Upload Sheets' && element.PView == false) {
                this.MarksDataUploadSheets = false;
              }
               if (element.PageName == 'Buffer_Student_Answersheet' && element.PView == false) {
                this.Buffer_Student_Answersheet = false;
              }
              if (element.PageName == 'ExamsEvalMarksReport' && element.PView == false) {
                this.ExamsEvalMarksReport = false;
              }
              //input

              if (element.PageName == 'Input' && element.PView == false) {
                this.inputMenu = false;
              }
              if (element.PageName == 'Registration Form' && element.PView == false) {
                this.RegistrationView = false;
              }
              if (element.PageName == 'Exam Input Form' && element.PView == false) {
                this.ExamInputView = false;
              }
              if (element.PageName == 'Center Allocation' && element.PView == false) {
                this.CenterView = false;
              }
              if (element.PageName == 'Center Allocation and Seat No' && element.PView == false) {
                this.New_CenterView = false;
              }
              if (element.PageName == 'College Capacity' && element.PView == false) {
                this.CollegeCapacity = false;
              }
              if (element.PageName == 'Barcode Name Slips' && element.PView == false) {
                this.BarcodeNameView = false;
              }
              if (element.PageName == 'Barcode Marks Slips' && element.PView == false) {
                this.BarcodeMarksView = false;
              }
              if (element.PageName == 'Control Sheets' && element.PView == false) {
                this.ControlSheetsView = false;
              }
              if (element.PageName == 'Marks By RollNo' && element.PView == false) {
                this.MarksByRollNoView = false;
              }
              if (element.PageName == 'Marks By Code' && element.PView == false) {
                this.MarksByCodeView = false;
              }
              if (element.PageName == 'Status Report' && element.PView == false) {
                this.StatusReportView = false;
              }
              if (element.PageName == 'Change Marks' && element.PView == false) {
                this.ChangeMarksView = false;
              }
              if (element.PageName == 'Section Marks' && element.PView == false) {
                this.SectionMarksView = false;
              }
              if (element.PageName == 'Dist Ass Marks' && element.PView == false) {
                this.DistAssMarksView = false;
              }
              if (element.PageName == 'IA Marks' && element.PView == false) {
                this.IAMarksView = false;
              }
              if (element.PageName == 'Student-Hold-Data' && element.PView == false) {
                this.StudentHoldData = false;
              }
              if (element.PageName == 'Student Status' && element.PView == false) {
                this.StudentStatus = false;
              }
              if (element.PageName == 'RevaluationView' && element.PView == false) {
                this.RevaluationView = false;
              }

              if (element.PageName == 'Packing List' && element.PView == false) {
                this.PackingList = false;
              }
              if (element.PageName == 'Subject Change' && element.PView == false) {
                this.SubjectChange = false;
              }
              if (element.PageName == 'Optional Subject Selection' && element.PView == false) {
                this.AdminOptionalSubjectSelection = false;
              }
              if (element.PageName == 'With Hold' && element.PView == false) {
                this.WithHold = false;
              }
              if (element.PageName == 'Upload-Student-Data' && element.PView == false) {
                this.UploadStudentData = false;
              }

              //reports

              if (element.PageName == 'Reports' && element.PView == false) {
                this.reportMenu = false;
              }
              //setting

              if (element.PageName == 'Setting' && element.PView == false) {
                this.settingMenu = false;
              }
              if (element.PageName == 'Student Profile Setting' && element.PView == false) {
                this.StudentProfileSettingView = false;
              }
              if (element.PageName == 'Exam Setup' && element.PView == false) {
                this.ExamSetupView = false;
              }
              if (element.PageName == 'Fee Head' && element.PView == false) {
                this.FeeHeadView = false;
              }
              if (element.PageName == 'Fee Template' && element.PView == false) {
                this.FeeTemplateView = false;
              }
              if (element.PageName == 'Fee Template Mapping' && element.PView == false) {
                this.FeeTemplateMappingView = false;
              }
              if (element.PageName == 'Fee Mode' && element.PView == false) {
                this.FeeModeView = false;
              }
              if (element.PageName == 'Apply Admission Fee' && element.PView == false) {
                this.ApplyFeeTemplateView = false;
              }
              if (element.PageName == 'Apply Exam Fee' && element.PView == false) {
                this.examFeeView = false;
              }

              if (element.PageName == 'Scrutiny Approval' && element.PView == false) {
                this.ScrutinyApprovalView = false;
              }
              if (element.PageName == 'Student Attendance' && element.PView == false) {
                this.StudentAttendanceView = false;
              }
              if (element.PageName == 'Student Practical Attendance' && element.PView == false) {
                this.StudentIAAttendanceView = false
              }
              if (element.PageName == 'Holiday Date' && element.PView == false) {
                this.holidayView = false
              }
              if (element.PageName == 'Parameter' && element.PView == false) {
                this.ParameterView = false
              }
              if (element.PageName == 'Grievance' && element.PView == false) {
                this.ComplaintView = false
              }
              if (element.PageName == 'slm' && element.PView == false) {
                this.SLMView = false
              }
              if (element.PageName == 'Publish Notification' && element.PView == false) {
                this.notificationsView = false;
              }
              if (element.PageName == 'Tentative Exam Schedule' && element.PView == false) {
                this.tentativeView = false;
              }
              if (element.PageName == 'Tentative Descriptive Schedule' && element.PView == false) {
                this.tentativeDetailsView = false;
              }
              if (element.PageName == 'Upload Student Photo And Sign' && element.PView == false) {
                this.UploadStudentPhotoAndSign = false;
              }
               if (element.PageName == 'Upload  Old Student Photo And Sign' && element.PView == false) {
                this.UploadOldStudentPhotoAndSign = false;
              }
               if (element.PageName == 'Upload  Old Student Photo And Sign' && element.PView == false) {
                this.UploadConvocation = false;
              }
              if (element.PageName == 'Student Exam Form College Report' && element.PView == false) {
                this.ExamFormCollegeReport = false;
              }
              if (element.PageName == 'IA Marks' && element.PView == false) {
                this.IAMarks = false;
              }
              if (element.PageName == 'practical-marks-report' && element.PView == false) { 
                this.PracticalMarksReport = false;
              }
              if (element.PageName == 'Practical Marks' && element.PView == false) {
                this.PracticalMarks = false;
              }
              if (element.PageName == 'collegewise-student-name-list' && element.PView == false) {
                this.collegewiselist = false;
              }
              if (element.PageName == 'Elective Marks' && element.PView == false) {
                this.ElectiveMarks = false;
              }
               if (element.PageName == 'Student Data Upload Report' && element.PView == false) {
                this.StudentSignPhotoUploadReport = false;
              }
              if (element.PageName == 'Block-Wise-Report' && element.PView == false) {
                this.BlockWiseReport = false;
              }
              if (element.PageName == 'Theory Exam Appointment' && element.PView == false) {
                this.TheoryExamAppointment = false;
              }
              // if (element.PageName == 'Dashboard' && element.PView == false) {
              //   this.dashboardMenu = false;
              //   this.redirect('HomePage')
              // }
              // else {
              //   this.dashboardMenu = true;
              //   this.redirect('home')
              // }
            });


          }
          else {
            this.dashboardMenu = false;
            this.masterMenu = false;
            this.superMenu = false;
            this.prcessMenu = false;
            this.adminMenu = false;
            this.inputMenu = false;
            this.settingMenu = false;
            this.reportMenu = false;
            this.CollegeView = false;
            this.FacultyView = false;
            this.CourseView = false;
            this.CoursewiseAttThresoldMasterView = false;
            this.CollegeMappingView = false;
            this.CodeTypeView = false;
            this.codetypeforadmin = false;
            this.ExamView = false;
            this.SubjectMappingView = false;
            this.ChoiceSubjectView = false;
            this.CountryView = false;
            this.StateView = false;
            this.DistrictView = false;
            this.DivisionView = false;
            this.TownView = false;
            this.TehasilView = false;
            this.AttendanceSettingView = false;
            this.IAAtdSettingView = false;
            this.Cast = false;
            this.SubCast = false;
            this.SessionView = false;
            this.SessionView = false;
            this.CourseIntakeMappingView = false;
            this.SessionCutoffView = false;
            this.SupervisorCourseView = false;
            this.SupervisorExamView = false;
            this.UserPermissionView = false;
            this.AssignLevelView = false;
            this.IAUserView = false;
            this.ExamScheduleView = false;
            this.ExamEditScheduleView = false;
            this.CourseScheduleView = false;
            this.CourseEditScheduleView = false;
            this.NewExamCodeView = false;
            this.ExamTimetableView = false;
            this.PracticalTimeTable = false;
            this.QuestionPaperCodesView = false;
            this.GenerateRegnNoView = false;
            this.GenerateRollNoView = false;
            this.GenerateSheetsView = false;
            this.GenerateCodesView = false;
            this.CenterCodesView = false;
            this.ZoneAllocationView = false;
            this.GenerateMarksFoilsView = false;
            this.ProcessResultView = false;
            this.UpdateResultsView = false;
            this.ReProcessResultView = false;
            this.SwitchSessionView = false;
            this.RegistrationView = false;
            this.ExamInputView = false;
            this.CenterView = false;
            this.New_CenterView = false;
            this.CollegeCapacity = false;
            this.BarcodeNameView = false;
            this.BarcodeMarksView = false;
            this.ControlSheetsView = false;
            this.MarksByRollNoView = false;
            this.MarksByCodeView = false;
            this.StatusReportView = false;
            this.ChangeMarksView = false;
            this.SectionMarksView = false;
            this.DistAssMarksView = false;
            this.IAMarksView = false;
            this.StudentHoldData = false;
            this.StudentProfileSettingView = false;
            this.ExamSetupView = false;
            this.FeeHeadView = false;
            this.FeeTemplateView = false;
            this.FeeTemplateMappingView = false;
            this.FeeModeView = false;
            this.ApplyFeeTemplateView = false;
            this.examFeeView = false;
            this.ScrutinyApprovalView = false;
            this.StudentAttendanceView = false;
            this.StudentIAAttendanceView = false;
            this.StudentStatus = false;
            this.PackingList = false;
            this.SubjectChange = false;
            this.AdminOptionalSubjectSelection = false;
            this.WithHold = false;
            this.UploadStudentData = false;
            this.CasteWiseIntakeView = false;
            this.holidayView = false
            this.ParameterView = false
            this.ComplaintView = false
            this.SLMView = false
            this.RevaluationView = false;
            this.notificationsView = false;
            this.tentativeView = false;
            this.tentativeDetailsView = false;
            this.UploadStudentPhotoAndSign = false;
            this.ExamFormCollegeReport = false;
            this.IAMarks = false;
            this.BlockWiseReport = false;
            this.MarksDataUploadSheets = false;
            this.Buffer_Student_Answersheet = false;
            this.ExamsEvalMarksReport = false;
            this.PracticalMarksReport = false;
            this.collegewiselist= false;
             this.PracticalMarks = false;
            this.ElectiveMarks = false;
            this.StudentSignPhotoUploadReport = false;
            this.DepartmentView = false;
            this.DepartmentSubjectMappingView = false;
            this.ExaminerView = false;
            this.ExaminerAvailability = false;
            this.PracticalExaminerAssignment = false;
             this.EligibilityCriteria = false;
            // this.redirect('HomePage')
          }
          // this.isSuperAdmin= false;

        }
        else {
          // this.redirect('home')
          this.dashboardMenu = true;
          this.codetypeforadmin = true;
          this.masterMenu = true;
          this.superMenu = true;
          this.prcessMenu = true;
          this.adminMenu = true;
          this.inputMenu = true;
          this.settingMenu = true;
          this.reportMenu = true;
          this.CollegeView = true;
          this.FacultyView = true;
          this.CourseView = true;
          this.CoursewiseAttThresoldMasterView = true;
          this.CollegeMappingView = true;
          this.CodeTypeView = true;
          this.codetypeforadmin = true;
          this.ExamView = true;
          this.SubjectMappingView = true;
          this.ChoiceSubjectView = true;
          this.CountryView = true;
          this.StateView = true;
          this.DistrictView = true;
          this.DivisionView = true;
          this.TownView = true;
          this.TehasilView = true;
          this.AttendanceSettingView = true;
          this.IAAtdSettingView = true;
          this.Cast = true;
          this.SubCast = true;
          this.SessionView = true;
          this.SessionView = true;
          this.CourseIntakeMappingView = true;
          this.SessionCutoffView = true;
          this.SupervisorCourseView = true;
          this.SupervisorExamView = true;
          this.UserPermissionView = true;
          this.AssignLevelView = true;
          this.IAUserView = true;
          this.ExamScheduleView = true;
          this.ExamEditScheduleView = true;
          this.CourseScheduleView = true;
          this.CourseEditScheduleView = true;
          this.NewExamCodeView = true;
          this.ExamTimetableView = true;
          this.PracticalTimeTable = true;
          this.QuestionPaperCodesView = true;
          this.GenerateRegnNoView = true;
          this.GenerateRollNoView = true;
          this.GenerateSheetsView = true;
          this.GenerateCodesView = true;
          this.CenterCodesView = true;
          this.ZoneAllocationView = true;
          this.GenerateMarksFoilsView = true;
          this.ProcessResultView = true;
          this.UpdateResultsView = true;
          this.ReProcessResultView = true;
          this.SwitchSessionView = true;
          this.RegistrationView = true;
          this.ExamInputView = true;
          this.CenterView = true;
          this.New_CenterView = true;
           this.CollegeCapacity = true;
          this.BarcodeNameView = true;
          this.BarcodeMarksView = true;
          this.ControlSheetsView = true;
          this.MarksByRollNoView = true;
          this.MarksByCodeView = true;
          this.StatusReportView = true;
          this.ChangeMarksView = true;
          this.SectionMarksView = true;
          this.DistAssMarksView = true;
          this.IAMarksView = true;
          this.StudentHoldData = true;
          this.StudentProfileSettingView = true;
          this.ExamSetupView = true;
          this.FeeHeadView = true;
          this.FeeTemplateView = true;
          this.FeeTemplateMappingView = true;
          this.FeeModeView = true;
          this.ApplyFeeTemplateView = true;
          this.examFeeView = true;
          this.ScrutinyApprovalView = true;
          this.StudentAttendanceView = true;
          this.StudentIAAttendanceView = true
          this.StudentStatus = true;
          this.PackingList = true;
          this.SubjectChange = true;
          this.AdminOptionalSubjectSelection = true;
          this.WithHold = true;
          this.UploadStudentData = true;
          this.CasteWiseIntakeView = true;
          this.holidayView = true;
          this.ParameterView = true;
          this.ComplaintView = true;
          this.SLMView = true;
          this.RevaluationView = true;
          this.notificationsView = true;
          this.tentativeView = true;
          this.tentativeDetailsView = true;
          this.UploadStudentPhotoAndSign = true;
          this.UploadOldStudentPhotoAndSign = true;
          this.UploadConvocation = true;
          this.ExamFormCollegeReport = true;
          this.IAMarks = true;
          this.BlockWiseReport = true;
          this.MarksDataUploadSheets = true;
          this.Buffer_Student_Answersheet = true;
          this.ExamsEvalMarksReport = true;
          this.PracticalMarksReport = true;
          this.collegewiselist =true;
          this.PracticalMarks = true;
          this.ElectiveMarks = true;
          this.StudentSignPhotoUploadReport = true;
          this.DepartmentView = true;
          this.DepartmentSubjectMappingView = true;
          this.ExaminerView = true;
          this.ExaminerAvailability = true;
          this.PracticalExaminerAssignment = true;
          this.EligibilityCriteria = true;
        }
      } else {
        this.dashboardMenu = false;
        this.masterMenu = false;
        this.superMenu = false;
        this.prcessMenu = false;
        this.adminMenu = false;
        this.inputMenu = false;
        this.settingMenu = false;
        this.reportMenu = false;
        this.CollegeView = false;
        this.FacultyView = false;
        this.CourseView = false;
        this.CoursewiseAttThresoldMasterView = false;
        this.CollegeMappingView = false;
        this.CodeTypeView = false;
        this.codetypeforadmin = false;
        this.ExamView = false;
        this.SubjectMappingView = false;
        this.ChoiceSubjectView = false;
        this.CountryView = false;
        this.StateView = false;
        this.DistrictView = false;
        this.DivisionView = false;
        this.TownView = false;
        this.TehasilView = false;
        this.AttendanceSettingView = false;
        this.IAAtdSettingView = false;
        this.Cast = false;
        this.SubCast = false;
        this.SessionView = false;
        this.SessionView = false;
        this.CourseIntakeMappingView = false;
        this.SessionCutoffView = false;
        this.SupervisorCourseView = false;
        this.SupervisorExamView = false;
        this.UserPermissionView = false;
        this.AssignLevelView = false;
        this.IAUserView = false;
        this.ExamScheduleView = false;
        this.ExamEditScheduleView = false;
        this.CourseScheduleView = false;
        this.CourseEditScheduleView = false;
        this.NewExamCodeView = false;
        this.ExamTimetableView = false;
        this.PracticalTimeTable = false;
         this.AssignPanelDate = false;
        this.QuestionPaperCodesView = false;
        this.GenerateRegnNoView = false;
        this.GenerateRollNoView = false;
        this.GenerateSheetsView = false;
        this.GenerateCodesView = false;
        this.CenterCodesView = false;
        this.ZoneAllocationView = false;
        this.GenerateMarksFoilsView = false;
        this.ProcessResultView = false;
        this.UpdateResultsView = false;
        this.ReProcessResultView = false;
        this.SwitchSessionView = false;
        this.RegistrationView = false;
        this.ExamInputView = false;
        this.CenterView = false;
        this.New_CenterView = false;
        this.CollegeCapacity = false;
        this.BarcodeNameView = false;
        this.BarcodeMarksView = false;
        this.ControlSheetsView = false;
        this.MarksByRollNoView = false;
        this.MarksByCodeView = false;
        this.StatusReportView = false;
        this.ChangeMarksView = false;
        this.SectionMarksView = false;
        this.DistAssMarksView = false;
        this.IAMarksView = false;
        this.StudentHoldData = false;
        this.StudentProfileSettingView = false;
        this.ExamSetupView = false;
        this.FeeHeadView = false;
        this.FeeTemplateView = false;
        this.FeeTemplateMappingView = false;
        this.FeeModeView = false;
        this.ApplyFeeTemplateView = false;
        this.examFeeView = false;
        this.ScrutinyApprovalView = false;
        this.StudentAttendanceView = false;
        this.StudentIAAttendanceView = false;
        this.StudentStatus = false;
        this.PackingList = false;
        this.SubjectChange = false;
        this.AdminOptionalSubjectSelection = false;
        this.WithHold = false;
        this.UploadStudentData = false;
        this.CasteWiseIntakeView = false;
        this.holidayView = false
        this.ParameterView = false
        this.ComplaintView = false
        this.SLMView = false
        this.RevaluationView = false;
        this.notificationsView = false;
        this.tentativeView = false;
        this.tentativeDetailsView = false;
        this.UploadStudentPhotoAndSign = false;
        this.UploadOldStudentPhotoAndSign = false;
        this.UploadConvocation = false;
        this.ExamFormCollegeReport = false;
        this.IAMarks = false;
        this.BlockWiseReport = false;
        this.MarksDataUploadSheets = false;
        this.Buffer_Student_Answersheet = false;
        this.ExamsEvalMarksReport = false;
        this.PracticalMarksReport = false;
        this.PracticalMarks = false;
        this.collegewiselist = false;
        this.ElectiveMarks = false;
        this.StudentSignPhotoUploadReport = false;
        this.DepartmentView = false;
        this.DepartmentSubjectMappingView = false;
        this.ExaminerView = false;
        this.ExaminerAvailability = false;
        this.PracticalExaminerAssignment = false;
        this.ExaminerEligibility = false;
        this.EligibilityCriteria = false;
        // this.redirect('HomePage')
      }

    });
  }




  hasChild = (_: number, node: FoodNode) =>
    !!node.children && node.children.length > 0;

  loadParentMenu() {
    this.umsService.getParentsMenu().subscribe((res) => {


      // tslint:disable-next-line:no-shadowed-variable

      const TREE_DATA: FoodNode[] = res.data;

      this.listParentMenu = res.data;

      this.dataSource.data = TREE_DATA;
    });
  }

  loadStudentMenu() {
    this.umsService.getStudentMenu().subscribe((res) => {


      // tslint:disable-next-line:no-shadowed-variable

      const TREE_DATA: FoodNode[] = res.data;

      this.dataSource.data = TREE_DATA;
    });
  }

  loadTeacherMenu() {
    this.umsService.getTeachersMenu().subscribe((res) => {


      // tslint:disable-next-line:no-shadowed-variable

      const TREE_DATA: FoodNode[] = res.data;

      this.dataSource.data = TREE_DATA;
    });
  }

  toggermenu(e) {
    if (e === true) {
      this.default = false;
    } else {
      this.default = true;
    }
  }

  switchsession = {
    'path': 'session-data',
    'code': 'switch-session'
  }
  redirectProcessing(to) {

    this.router.navigate([to.path], { queryParams: { MenuCode: to.code } });
  }

  redirectProcessing1(path, code) {
    this.router.navigate([path], { queryParams: { MenuCode: code } });
  }
  redirect(to): void {
    this.router.navigate([to]);;
  }
  x = ""
  colorchnage(e) {
    // alert(this.x)
    if (this.x == "") {
      document.getElementById(e).setAttribute('class', 'nav-sub-link active');
      this.x = e;
    } else if (this.x !== e) {
      document.getElementById(this.x).setAttribute('class', 'nav-sub-link');
      document.getElementById(e).setAttribute('class', 'nav-sub-link active');
      this.x = e;
    } else {
      document.getElementById(this.x).setAttribute('class', 'nav-sub-link');
      document.getElementById(e).setAttribute('class', 'nav-sub-link active');
      this.x = e;
    }
    // document.getElementById(this.x).setAttribute('class', 'nav-sub-link');


  }
  changetheme(e) {
    if (e == 'master') {
      document.getElementById(e).setAttribute('class', 'nav-item active show ');

      document.getElementById('dashboard').setAttribute('class', 'nav-item ');

      document.getElementById('settings').setAttribute('class', 'nav-item ');

      document.getElementById('admin').setAttribute('class', 'nav-item ');

      // document.getElementById('location').setAttribute('class', 'nav-item ');

      document.getElementById('processing').setAttribute('class', 'nav-item ');

      document.getElementById('inputs').setAttribute('class', 'nav-item ');

      document.getElementById('supervisor').setAttribute('class', 'nav-item ');

      // document.getElementById('CentreAssignmentReports').setAttribute('class', 'nav-item ');

      // document.getElementById('CourseReports').setAttribute('class', 'nav-item ');

      // document.getElementById('Post_Exam_Reports').setAttribute('class', 'nav-item ');

      // document.getElementById('PreExamReports').setAttribute('class', 'nav-item ');

      // document.getElementById('Scrutiny').setAttribute('class', 'nav-item ');

      // document.getElementById('Fees').setAttribute('class', 'nav-item ');

      document.getElementById('Reports').setAttribute('class', 'nav-item ');

    } else if (e == 'dashboard') {
      document.getElementById(e).setAttribute('class', 'nav-item active show');

      document.getElementById('master').setAttribute('class', 'nav-item ');

      document.getElementById('settings').setAttribute('class', 'nav-item ');

      // document.getElementById('location').setAttribute('class', 'nav-item ');

      document.getElementById('admin').setAttribute('class', 'nav-item ');

      document.getElementById('processing').setAttribute('class', 'nav-item ');

      document.getElementById('inputs').setAttribute('class', 'nav-item ');

      document.getElementById('supervisor').setAttribute('class', 'nav-item ');

      // document.getElementById('CentreAssignmentReports').setAttribute('class', 'nav-item ');

      // document.getElementById('CourseReports').setAttribute('class', 'nav-item ');

      // document.getElementById('Post_Exam_Reports').setAttribute('class', 'nav-item ');

      // document.getElementById('PreExamReports').setAttribute('class', 'nav-item ');

      // document.getElementById('Scrutiny').setAttribute('class', 'nav-item ');
      // document.getElementById('Fees').setAttribute('class', 'nav-item ');


      document.getElementById('Reports').setAttribute('class', 'nav-item ');
    }
    //  else if (e == 'location') {
    //   document.getElementById(e).setAttribute('class', 'nav-item active show');

    //   document.getElementById('master').setAttribute('class', 'nav-item ');

    //   document.getElementById('settings').setAttribute('class', 'nav-item ');

    //   document.getElementById('dashboard').setAttribute('class', 'nav-item ');

    //   document.getElementById('admin').setAttribute('class', 'nav-item ');

    //   document.getElementById('processing').setAttribute('class', 'nav-item ');

    //   document.getElementById('inputs').setAttribute('class', 'nav-item ');

    //   document.getElementById('supervisor').setAttribute('class', 'nav-item ');
    // } 
    else if (e == 'admin') {
      document.getElementById(e).setAttribute('class', 'nav-item active show');

      document.getElementById('master').setAttribute('class', 'nav-item ');

      document.getElementById('settings').setAttribute('class', 'nav-item ');

      document.getElementById('dashboard').setAttribute('class', 'nav-item ');

      // document.getElementById('location').setAttribute('class', 'nav-item ');

      document.getElementById('processing').setAttribute('class', 'nav-item ');

      document.getElementById('inputs').setAttribute('class', 'nav-item ');

      document.getElementById('supervisor').setAttribute('class', 'nav-item ');

      // document.getElementById('CentreAssignmentReports').setAttribute('class', 'nav-item ');

      // document.getElementById('CourseReports').setAttribute('class', 'nav-item ');

      // document.getElementById('Post_Exam_Reports').setAttribute('class', 'nav-item ');

      // document.getElementById('PreExamReports').setAttribute('class', 'nav-item ');

      // document.getElementById('Scrutiny').setAttribute('class', 'nav-item ');

      // document.getElementById('Fees').setAttribute('class', 'nav-item ');


      document.getElementById('Reports').setAttribute('class', 'nav-item ');
    }
    else if (e == 'settings') {
      document.getElementById(e).setAttribute('class', 'nav-item active show');

      document.getElementById('master').setAttribute('class', 'nav-item ');

      document.getElementById('admin').setAttribute('class', 'nav-item ');

      document.getElementById('dashboard').setAttribute('class', 'nav-item ');

      // document.getElementById('location').setAttribute('class', 'nav-item ');

      document.getElementById('processing').setAttribute('class', 'nav-item ');

      document.getElementById('inputs').setAttribute('class', 'nav-item ');

      document.getElementById('supervisor').setAttribute('class', 'nav-item ');

      // document.getElementById('CentreAssignmentReports').setAttribute('class', 'nav-item ');

      // document.getElementById('CourseReports').setAttribute('class', 'nav-item ');

      // document.getElementById('Post_Exam_Reports').setAttribute('class', 'nav-item ');

      // document.getElementById('PreExamReports').setAttribute('class', 'nav-item ');

      // document.getElementById('Scrutiny').setAttribute('class', 'nav-item ');

      // document.getElementById('Fees').setAttribute('class', 'nav-item ');

      document.getElementById('Reports').setAttribute('class', 'nav-item ');

    } else if (e == 'processing') {
      document.getElementById(e).setAttribute('class', 'nav-item active show');

      document.getElementById('master').setAttribute('class', 'nav-item ');

      document.getElementById('admin').setAttribute('class', 'nav-item ');

      document.getElementById('dashboard').setAttribute('class', 'nav-item ');

      // document.getElementById('location').setAttribute('class', 'nav-item ');

      document.getElementById('settings').setAttribute('class', 'nav-item ');

      document.getElementById('inputs').setAttribute('class', 'nav-item ');

      document.getElementById('supervisor').setAttribute('class', 'nav-item ');

      // document.getElementById('CentreAssignmentReports').setAttribute('class', 'nav-item ');

      // document.getElementById('CourseReports').setAttribute('class', 'nav-item ');

      // document.getElementById('Post_Exam_Reports').setAttribute('class', 'nav-item ');

      // document.getElementById('PreExamReports').setAttribute('class', 'nav-item ');

      // document.getElementById('Scrutiny').setAttribute('class', 'nav-item ');

      // document.getElementById('Fees').setAttribute('class', 'nav-item ');

      document.getElementById('Reports').setAttribute('class', 'nav-item ');
    }
    else if (e == 'inputs') {
      document.getElementById(e).setAttribute('class', 'nav-item active show');

      document.getElementById('master').setAttribute('class', 'nav-item ');

      document.getElementById('admin').setAttribute('class', 'nav-item ');

      document.getElementById('dashboard').setAttribute('class', 'nav-item ');

      // document.getElementById('location').setAttribute('class', 'nav-item ');

      document.getElementById('settings').setAttribute('class', 'nav-item ');

      document.getElementById('processing').setAttribute('class', 'nav-item ');

      document.getElementById('supervisor').setAttribute('class', 'nav-item ');

      // document.getElementById('CentreAssignmentReports').setAttribute('class', 'nav-item ');

      // document.getElementById('CourseReports').setAttribute('class', 'nav-item ');

      // document.getElementById('Post_Exam_Reports').setAttribute('class', 'nav-item ');

      // document.getElementById('PreExamReports').setAttribute('class', 'nav-item ');

      // document.getElementById('Scrutiny').setAttribute('class', 'nav-item ');

      // document.getElementById('Fees').setAttribute('class', 'nav-item ');

      document.getElementById('Reports').setAttribute('class', 'nav-item ');
    }

    else if (e == 'supervisor') {
      document.getElementById(e).setAttribute('class', 'nav-item active show');

      document.getElementById('master').setAttribute('class', 'nav-item ');

      document.getElementById('admin').setAttribute('class', 'nav-item ');

      document.getElementById('dashboard').setAttribute('class', 'nav-item ');

      // document.getElementById('location').setAttribute('class', 'nav-item ');

      document.getElementById('settings').setAttribute('class', 'nav-item ');

      document.getElementById('processing').setAttribute('class', 'nav-item ');

      document.getElementById('inputs').setAttribute('class', 'nav-item ');

      // document.getElementById('CentreAssignmentReports').setAttribute('class', 'nav-item ');

      // document.getElementById('CourseReports').setAttribute('class', 'nav-item ');

      // document.getElementById('Post_Exam_Reports').setAttribute('class', 'nav-item ');

      // document.getElementById('PreExamReports').setAttribute('class', 'nav-item ');

      // document.getElementById('Scrutiny').setAttribute('class', 'nav-item ');

      // document.getElementById('Fees').setAttribute('class', 'nav-item ');

      document.getElementById('Reports').setAttribute('class', 'nav-item ');

    }
    // else if (e == 'CentreAssignmentReports') {
    //   document.getElementById(e).setAttribute('class', 'nav-item active show');

    //   document.getElementById('master').setAttribute('class', 'nav-item ');

    //   document.getElementById('admin').setAttribute('class', 'nav-item ');

    //   document.getElementById('dashboard').setAttribute('class', 'nav-item ');

    //   // document.getElementById('location').setAttribute('class', 'nav-item ');

    //   document.getElementById('settings').setAttribute('class', 'nav-item ');

    //   document.getElementById('processing').setAttribute('class', 'nav-item ');

    //   document.getElementById('inputs').setAttribute('class', 'nav-item ');

    //   document.getElementById('supervisor').setAttribute('class', 'nav-item ');

    //   document.getElementById('CourseReports').setAttribute('class', 'nav-item ');

    //   document.getElementById('Post_Exam_Reports').setAttribute('class', 'nav-item ');

    //   document.getElementById('PreExamReports').setAttribute('class', 'nav-item ');

    //   // document.getElementById('Scrutiny').setAttribute('class', 'nav-item ');

    //   // document.getElementById('Fees').setAttribute('class', 'nav-item ');
    // }
    // else if (e == 'CourseReports') {
    //   document.getElementById(e).setAttribute('class', 'nav-item active show');

    //   document.getElementById('master').setAttribute('class', 'nav-item ');

    //   document.getElementById('admin').setAttribute('class', 'nav-item ');

    //   document.getElementById('dashboard').setAttribute('class', 'nav-item ');

    //   // document.getElementById('location').setAttribute('class', 'nav-item ');

    //   document.getElementById('settings').setAttribute('class', 'nav-item ');

    //   document.getElementById('processing').setAttribute('class', 'nav-item ');

    //   document.getElementById('inputs').setAttribute('class', 'nav-item ');

    //   document.getElementById('supervisor').setAttribute('class', 'nav-item ');

    //   document.getElementById('CentreAssignmentReports').setAttribute('class', 'nav-item ');

    //   document.getElementById('Post_Exam_Reports').setAttribute('class', 'nav-item ');

    //   document.getElementById('PreExamReports').setAttribute('class', 'nav-item ');

    //   // document.getElementById('Scrutiny').setAttribute('class', 'nav-item ');

    //   // document.getElementById('Fees').setAttribute('class', 'nav-item ');

    // }
    // else if (e == 'Post_Exam_Reports') {
    //   document.getElementById(e).setAttribute('class', 'nav-item active show');

    //   document.getElementById('master').setAttribute('class', 'nav-item ');

    //   document.getElementById('admin').setAttribute('class', 'nav-item ');

    //   document.getElementById('dashboard').setAttribute('class', 'nav-item ');

    //   // document.getElementById('location').setAttribute('class', 'nav-item ');

    //   document.getElementById('settings').setAttribute('class', 'nav-item ');

    //   document.getElementById('processing').setAttribute('class', 'nav-item ');

    //   document.getElementById('inputs').setAttribute('class', 'nav-item ');

    //   document.getElementById('supervisor').setAttribute('class', 'nav-item ');

    //   document.getElementById('CourseReports').setAttribute('class', 'nav-item ');

    //   document.getElementById('CentreAssignmentReports').setAttribute('class', 'nav-item ');

    //   document.getElementById('PreExamReports').setAttribute('class', 'nav-item ');

    //   // document.getElementById('Scrutiny').setAttribute('class', 'nav-item ');

    //   // document.getElementById('Fees').setAttribute('class', 'nav-item ');

    // }
    // else if (e == 'PreExamReports') {
    //   document.getElementById(e).setAttribute('class', 'nav-item active show');

    //   document.getElementById('master').setAttribute('class', 'nav-item ');

    //   document.getElementById('admin').setAttribute('class', 'nav-item ');

    //   document.getElementById('dashboard').setAttribute('class', 'nav-item ');

    //   // document.getElementById('location').setAttribute('class', 'nav-item ');

    //   document.getElementById('settings').setAttribute('class', 'nav-item ');

    //   document.getElementById('processing').setAttribute('class', 'nav-item ');

    //   document.getElementById('inputs').setAttribute('class', 'nav-item ');

    //   document.getElementById('supervisor').setAttribute('class', 'nav-item ');

    //   document.getElementById('CourseReports').setAttribute('class', 'nav-item ');

    //   document.getElementById('CentreAssignmentReports').setAttribute('class', 'nav-item ');

    //   document.getElementById('Post_Exam_Reports').setAttribute('class', 'nav-item ');

    //   // document.getElementById('Scrutiny').setAttribute('class', 'nav-item ');

    //   // document.getElementById('Fees').setAttribute('class', 'nav-item ');
    // }
    // else if(e == 'Scrutiny') {
    //   document.getElementById(e).setAttribute('class', 'nav-item active show');

    //   document.getElementById('master').setAttribute('class', 'nav-item ');

    //   document.getElementById('admin').setAttribute('class', 'nav-item ');

    //   document.getElementById('dashboard').setAttribute('class', 'nav-item ');

    //   // document.getElementById('location').setAttribute('class', 'nav-item ');

    //   document.getElementById('settings').setAttribute('class', 'nav-item ');

    //   document.getElementById('processing').setAttribute('class', 'nav-item ');

    //   document.getElementById('inputs').setAttribute('class', 'nav-item ');

    //   document.getElementById('supervisor').setAttribute('class', 'nav-item ');

    //   document.getElementById('CourseReports').setAttribute('class', 'nav-item ');

    //   document.getElementById('CentreAssignmentReports').setAttribute('class', 'nav-item ');

    //   document.getElementById('Post_Exam_Reports').setAttribute('class', 'nav-item ');

    //   document.getElementById('PreExamReports').setAttribute('class', 'nav-item ');

    //   document.getElementById('Fees').setAttribute('class', 'nav-item ');
    // }
    // else if(e == 'Fees') {
    //   document.getElementById(e).setAttribute('class', 'nav-item active show');

    //   document.getElementById('master').setAttribute('class', 'nav-item ');

    //   document.getElementById('admin').setAttribute('class', 'nav-item ');

    //   document.getElementById('dashboard').setAttribute('class', 'nav-item ');

    //   // document.getElementById('location').setAttribute('class', 'nav-item ');

    //   document.getElementById('settings').setAttribute('class', 'nav-item ');

    //   document.getElementById('processing').setAttribute('class', 'nav-item ');

    //   document.getElementById('inputs').setAttribute('class', 'nav-item ');

    //   document.getElementById('supervisor').setAttribute('class', 'nav-item ');

    //   document.getElementById('CourseReports').setAttribute('class', 'nav-item ');

    //   document.getElementById('CentreAssignmentReports').setAttribute('class', 'nav-item ');

    //   document.getElementById('Post_Exam_Reports').setAttribute('class', 'nav-item ');

    //   document.getElementById('PreExamReports').setAttribute('class', 'nav-item ');

    //   document.getElementById('Scrutiny').setAttribute('class', 'nav-item ');
    // }

    else if (e == 'Reports') {
      document.getElementById(e).setAttribute('class', 'nav-item active show');

      document.getElementById('master').setAttribute('class', 'nav-item ');

      document.getElementById('admin').setAttribute('class', 'nav-item ');

      document.getElementById('dashboard').setAttribute('class', 'nav-item ');

      // document.getElementById('location').setAttribute('class', 'nav-item ');

      document.getElementById('settings').setAttribute('class', 'nav-item ');

      document.getElementById('processing').setAttribute('class', 'nav-item ');

      document.getElementById('inputs').setAttribute('class', 'nav-item ');

      document.getElementById('supervisor').setAttribute('class', 'nav-item ');

      // document.getElementById('CourseReports').setAttribute('class', 'nav-item ');

      // document.getElementById('CentreAssignmentReports').setAttribute('class', 'nav-item ');

      // document.getElementById('Post_Exam_Reports').setAttribute('class', 'nav-item ');

      // document.getElementById('PreExamReports').setAttribute('class', 'nav-item ');

      document.getElementById('Scrutiny').setAttribute('class', 'nav-item ');
    }


    else {
      document.getElementById('dashboard').setAttribute('class', 'nav-item ');

      document.getElementById('master').setAttribute('class', 'nav-item');

      document.getElementById(e).setAttribute('class', 'nav-item active show ');

      // document.getElementById('location').setAttribute('class', 'nav-item ');

      document.getElementById('processing').setAttribute('class', 'nav-item ');

      document.getElementById('inputs').setAttribute('class', 'nav-item ');

      document.getElementById('supervisor').setAttribute('class', 'nav-item ');

      // document.getElementById('CentreAssignmentReports').setAttribute('class', 'nav-item ');

      // document.getElementById('Post_Exam_Reports').setAttribute('class', 'nav-item ');

      // document.getElementById('PreExamReports').setAttribute('class', 'nav-item ');

      // document.getElementById('Scrutiny').setAttribute('class', 'nav-item ');

      // document.getElementById('Fees').setAttribute('class', 'nav-item ');
      document.getElementById('Reports').setAttribute('class', 'nav-item ');
    }
  }

  theme(i) {
    if (i == 'white') {
      this.elRef.nativeElement.style.setProperty(
        '--primary-gradent-one',
        'gray'
      );

      this.elRef.nativeElement.style.setProperty(
        '--primary-gradent-two',
        '#aaaaaa'
      );

      this.elRef.nativeElement.style.setProperty('--primary-bg-color', 'gray');

      this.elRef.nativeElement.style.setProperty('--dark-border', 'gray');

      this.elRef.nativeElement.style.setProperty(
        '--main-content-title',
        'gray'
      );

      this.elRef.nativeElement.style.setProperty(
        '--breadcrumb-lable-1',
        'black'
      );

      this.elRef.nativeElement.style.setProperty(
        '--breadcrumb-lable-2',
        'black'
      );

      this.elRef.nativeElement.style.setProperty('--side-sub-link', 'white');

      localStorage.setItem('theme', i);
    } else if (i == 'yellow') {
      this.elRef.nativeElement.style.setProperty(
        '--primary-gradent-one',
        '#ffab00'
      );

      this.elRef.nativeElement.style.setProperty(
        '--primary-gradent-two',
        '#efb960'
      );

      this.elRef.nativeElement.style.setProperty(
        '--primary-bg-color',
        '#ffab00'
      );

      this.elRef.nativeElement.style.setProperty('--dark-border', '#ffab00');

      this.elRef.nativeElement.style.setProperty(
        '--main-content-title',
        '#ffab00'
      );

      this.elRef.nativeElement.style.setProperty(
        '--breadcrumb-lable-1',
        '#ffb10f'
      );

      this.elRef.nativeElement.style.setProperty(
        '--breadcrumb-lable-2',
        '#f0d6a1'
      );

      this.elRef.nativeElement.style.setProperty('--side-sub-link', 'white');

      localStorage.setItem('theme', i);
    } else if (i == 'red') {
      this.elRef.nativeElement.style.setProperty(
        '--primary-gradent-one',
        '#ff4a42'
      );

      this.elRef.nativeElement.style.setProperty(
        '--primary-gradent-two',
        '#ef8d89'
      );

      this.elRef.nativeElement.style.setProperty(
        '--primary-bg-color',
        '#ff4a42'
      );

      this.elRef.nativeElement.style.setProperty('--dark-border', '#ff4a42');

      this.elRef.nativeElement.style.setProperty(
        '--main-content-title',
        '#ff4a42'
      );

      this.elRef.nativeElement.style.setProperty(
        '--breadcrumb-lable-1',
        '#ff4a42'
      );

      this.elRef.nativeElement.style.setProperty(
        '--breadcrumb-lable-2',
        '#ff4a42'
      );

      this.elRef.nativeElement.style.setProperty('--side-sub-link', 'white');

      localStorage.setItem('theme', i);
    } else if (i == 'green') {
      this.elRef.nativeElement.style.setProperty(
        '--primary-gradent-one',
        'green'
      );

      this.elRef.nativeElement.style.setProperty(
        '--primary-gradent-two',
        '#85b87f'
      );

      this.elRef.nativeElement.style.setProperty('--primary-bg-color', 'green');

      this.elRef.nativeElement.style.setProperty('--dark-border', 'green');

      this.elRef.nativeElement.style.setProperty(
        '--main-content-title',
        'green'
      );

      this.elRef.nativeElement.style.setProperty(
        '--breadcrumb-lable-1',
        'green'
      );

      this.elRef.nativeElement.style.setProperty(
        '--breadcrumb-lable-2',
        'green'
      );

      this.elRef.nativeElement.style.setProperty('--side-sub-link', 'white');

      localStorage.setItem('theme', i);
    } else if (i == 'sky_blue') {
      this.elRef.nativeElement.style.setProperty(
        '--primary-gradent-one',
        '#03a2e2'
      );

      this.elRef.nativeElement.style.setProperty(
        '--primary-gradent-two',
        '#96d1f1'
      );

      this.elRef.nativeElement.style.setProperty(
        '--primary-bg-color',
        '#03a2e2'
      );

      this.elRef.nativeElement.style.setProperty('--dark-border', '#03a2e2');

      this.elRef.nativeElement.style.setProperty(
        '--main-content-title',
        '#03a2e2'
      );

      this.elRef.nativeElement.style.setProperty(
        '--breadcrumb-lable-1',
        '#03a2e2'
      );

      this.elRef.nativeElement.style.setProperty(
        '--breadcrumb-lable-2',
        '#03a2e2'
      );

      this.elRef.nativeElement.style.setProperty('--side-sub-link', 'white');

      localStorage.setItem('theme', i);
    } else {
      this.elRef.nativeElement.style.setProperty(
        '--primary-gradent-one',
        '#1254f4'
      );

      this.elRef.nativeElement.style.setProperty(
        '--primary-gradent-two',
        '#1254f4'
      );

      this.elRef.nativeElement.style.setProperty(
        '--primary-bg-color',
        '#1254f4'
      );

      this.elRef.nativeElement.style.setProperty('--dark-border', '#1254f4');

      this.elRef.nativeElement.style.setProperty(
        '--main-content-title',
        '#1254f4'
      );

      this.elRef.nativeElement.style.setProperty(
        '--breadcrumb-lable-1',
        '#7787bc'
      );

      this.elRef.nativeElement.style.setProperty(
        '--breadcrumb-lable-2',
        '#8f9cc0'
      );

      this.elRef.nativeElement.style.setProperty('--side-sub-link', '#c7c7c7');

      localStorage.setItem('theme', i);
    }
  }

  mysecret() {
    this.umsService.getsecreat('').subscribe(res => {
      this.currentsession = sessionStorage.getItem("session");
      if (this.currentsession == null) {
        this.umsService.secret(res.projectPharam);
      } else {
        let data = JSON.parse(this.currentsession)
        res.projectPharam['SnCode'] = data['SnCode']
        res.projectPharam['SnDefault'] = data['SnDefault']
        res.projectPharam['SnName'] = data['SnName']
        res.projectPharam['SnNo'] = data['SnNo']
        res.projectPharam['SnStatus'] = data['SnStatus']
        res.projectPharam['SnYear'] = data['SnYear']
        this.umsService.secret(res.projectPharam);
      }
      // if()
      // 
    });
  }
  // logout() {
  //   sessionStorage.clear();
  //   localStorage.clear();
  // }
  logout() {
    sessionStorage.removeItem('token');
    sessionStorage.clear();
    localStorage.clear();
  }

  toggleSubMenu(menu: string): void {
    if (this.activeMenu === menu) {
      this.activeMenu = '';
      document.getElementById(menu).setAttribute('class', 'nav-item ');
    }
    else {
      this.activeMenu = menu;
      document.getElementById(this.activeMenu).setAttribute('class', 'nav-item active show');
    }
  }
  isMenuActive(menu: string): boolean {
    return this.activeMenu === menu;
  }

  changePassword() {
    // this.redirect('change-password')
    const dialogRef = this.dialog.open(ChangePasswordComponent, {
      width: '37%',
      data: { key: "New" },
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      // Handle dialog close actions or data here
      // this.getUserData();
      // this.UserSearch.controls['SearchString'].setValue('');
    });
  }


  zoom(action: string) {
    switch (action) {
      case 'A':
        this.zoomLevel = 1;
        break;
      case '-':
        if (this.zoomLevel > 0.5) {
          this.zoomLevel = Math.max(0.5, this.zoomLevel - 0.1);
        }
        break;
      case '+':
        if (this.zoomLevel < 1.5) {
          this.zoomLevel = Math.min(1.5, this.zoomLevel + 0.1);
        }
        break;
    }
    this.applyZoom();
  }

  applyZoom() {
    const content = document.querySelector('body') as any;
    if (content) {
      content.style.zoom = this.zoomLevel;
    }
  }

  getSecretData() {
    let payload = {};
    this.umsService.getSecretData().subscribe((res) => {
      let activeFlowObject = res.projectPharam['ActiveFlow']
      let arrActiveFlow = JSON.parse(activeFlowObject);
      if (arrActiveFlow[0]['SkipAttendance'] == 1) {
        this.SkipAttendance = true;
      }
      else if (arrActiveFlow[0]['SkipAttendance'] == 0) {
        this.SkipAttendance = false;
      }


    })
  }

  ShowNotification(dropdown: HTMLElement) {
    this.spinner.show();
    this.renderer.removeClass(dropdown, 'show');
    const distinctNotifications = this.NotificationAllData.filter((item, index, self) =>
      index === self.findIndex((t) => t.NotTitle === item.NotTitle && t.NotDesc === item.NotDesc)
    );
    const unreadNotificationIds = distinctNotifications
      .filter(notification => notification.ReadStatus === 'N')
    let iserror = false;
    const payload = unreadNotificationIds.map(notification => ({
      ...notification,
      ReadStatus: 'Y' // Update ReadStatus to 'Y'
    }));

    if (unreadNotificationIds.length > 0) {
      var bar = new Promise<void>((resolve, reject) => {
        payload.forEach((element, index, array) => {
          setTimeout(() => {
            this.umsService.UpdtStuNotify(element).subscribe(res => {
              // this.spinner.hide();
              if (res.status == false) {
                // this.spinner.hide()
                iserror = true;
                this.errMsg = res.message;
              } else {
                // this.spinner.hide()
                iserror = false;
                this.errMsg = res.message;
              }
              if (index === array.length - 1) resolve();
              // this.fetchDocument();

            }, (ERROR: HttpErrorResponse) => {
              this.spinner.hide()
              iserror = true;
              this.errMsg = ERROR.error.message;
              if (index === array.length - 1) resolve();
            });
          }, index * 2000);
        });

      })
      bar.then(() => {
        // this.spinner.hide();
        if (iserror == false) {
          this.spinner.hide();
          this.redirect('adminNotification');
          this.NotificationCount = 0;
        } else {
          this.spinner.hide();

        }
      });
    }
    else {
      this.redirect('adminNotification');
    }


    // this.redirect('adminNotification')

  }


  getList(data, SnNo) {
    if (data.CgUi == 'C') {
      this.UserCollege = data.CgId;
    }
    else {
      this.UserCollege = ''
    }
    this.spinner.show();
    const payload = {
      CoCode: '',
      SnNo: SnNo,
      CgCode: this.UserCollege,
      ApplicationType: 'Admin',
    };
    this.umsService.getStuNotify(payload).subscribe(
      (res) => {
        this.spinner.hide();
        if (res.status) {
          const distinctNotifications = res.data.filter((item, index, self) =>
            index === self.findIndex((t) => t.NotTitle === item.NotTitle && t.NotDesc === item.NotDesc)
          );
          this.NotificationCount = distinctNotifications.filter(item => item.ReadStatus == 'N').length;
          this.NotificationAllData = res.data;
          this.NotificationsData = distinctNotifications.map((item: any) => ({
            title: item.NotTitle,
            description: item.NotDesc,
            date: item.CreatedAt ? new Date(item.CreatedAt) : new Date('2000-01-01T00:00:00') // Default date
          }));
        } else {
          this.NotificationCount = 0;
          this.NotificationsData = [];
        }
      },
      (error: HttpErrorResponse) => {
        this.spinner.hide();
        console.error('Error fetching notifications:', error);
        this.NotificationCount = 0;
        this.NotificationsData = [];
      }
    );
  }
}